import nodeApi from '../utils/nodeApiClient';

const authApi = {
  getCaptcha: () => nodeApi.get('/auth/captcha'),
  login: (username, password, captchaId, captcha) =>
    nodeApi.post('/auth/login', { username, password, captcha_id: captchaId, captcha }),
  verifyOtp: (challengeToken, otp) =>
    nodeApi.post('/auth/verify-otp', { challenge_token: challengeToken, otp }),
  resendOtp: (challengeToken) => nodeApi.post('/auth/resend-otp', { challenge_token: challengeToken }),
  // Token passed explicitly: logout() clears localStorage right after firing this.
  logout: (token) => nodeApi.post('/auth/logout', null, { headers: { Authorization: `Bearer ${token}` } }),
  verify: () => nodeApi.get('/auth/verify'),
  changePassword: (data) => nodeApi.post('/auth/change-password', data),
  forgotPassword: (usernameOrEmail) => nodeApi.post('/auth/forgot-password', { username_or_email: usernameOrEmail }),
  forgotPasswordVerifyOtp: (challengeToken, otp) =>
    nodeApi.post('/auth/forgot-password/verify-otp', { challenge_token: challengeToken, otp }),
  forgotPasswordResendOtp: (challengeToken) =>
    nodeApi.post('/auth/forgot-password/resend-otp', { challenge_token: challengeToken }),
  forgotPasswordReset: (resetToken, newPassword, confirmPassword) =>
    nodeApi.post('/auth/forgot-password/reset', { reset_token: resetToken, new_password: newPassword, confirm_password: confirmPassword }),
  getProfile: () => nodeApi.get('/auth/profile'),
  updateProfile: (data) => nodeApi.put('/auth/profile', data),
  uploadProfileImage: (formData) =>
    nodeApi.post('/auth/profile/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
};

export default authApi;
